export default {
	default: [''],
	leftLabel: ['date-picker--left-label']
};
